/**
 * Australian dollars, the only currency this portal deals in.
 *
 * Amounts arrive as numbers of dollars, not cents. Rounding happens at the
 * formatter rather than in the arithmetic, so a total is never the sum of
 * already-rounded parts.
 */
const AUD = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCurrency = (amount: number): string =>
  AUD.format(Number.isFinite(amount) ? amount : 0);

/** GST on agent fees. The legacy portal multiplied by 1.1 inline in JSX — a tax
 *  rate scattered across render functions is one deploy away from disagreeing
 *  with itself, which here means a quoted total that differs from the charge. */
export const GST_RATE = 0.1;

export const withGst = (amount: number): number =>
  Math.round(amount * (1 + GST_RATE) * 100) / 100;
